"use strict";
import { Tags } from "./src/Tags.dev.js";
import { defineElement } from "@spectrum-web-components/base/src/define-element.js";
defineElement("sp-tags", Tags);
//# sourceMappingURL=sp-tags.dev.js.map
